import { WhenInjuryHappened } from './WhenInjuryHappend';
import { SpecificOrOverTimeInjury } from './SpecificOrOverTimeInjury';
import { InjuryDetails } from './InjuryDetails';
import { IsThereInjuryReport } from './IsThereInjuryReport';

export const InjuryTraumaQuestionnaire = () => {
  return (
    <>
      <SpecificOrOverTimeInjury />
      <WhenInjuryHappened />
      <InjuryDetails />
      <IsThereInjuryReport />
    </>
  );
};
